import { Box } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { tokens } from "../../theme";

/**
 * Tipografía del Design Kit para el HTML enriquecido de los bloques.
 *
 * Vive suelto porque `ContenidoNavegable` pinta el mismo contenido por trozos
 * (una sección plegable por título) y tiene que verse idéntico a esta vista.
 */
export const estilosContenido: SxProps<Theme> = {
  color: "text.primary",
  "& h2": {
    fontFamily: tokens.fuente.titulos,
    fontWeight: 700,
    fontSize: { xs: 24, md: 30 },
    color: tokens.marca.texto,
    mt: 6,
    mb: 2,
    pb: 1,
    borderBottom: "2px solid",
    borderColor: "divider",
  },
  "& h2:first-of-type": { mt: 0 },
  "& h3": {
    fontFamily: tokens.fuente.titulos,
    fontWeight: 600,
    fontSize: { xs: 17, md: 19 },
    mt: 4,
    mb: 1,
  },
  "& p": { fontSize: 15.5, lineHeight: 1.75, my: 1.5, textAlign: "justify", hyphens: "auto" },
  "& ul, & ol": { pl: 3, my: 1.5 },
  "& li": { fontSize: 15.5, lineHeight: 1.7, mb: 0.75 },
  "& a": {
    color: tokens.marca.enlace,
    fontWeight: 600,
    textDecoration: "none",
    "&:hover": { textDecoration: "underline" },
  },
  "& strong, & b": { fontWeight: 700 },
  "& mark": { backgroundColor: tokens.marca.resaltado, color: "text.primary", padding: "0.05em 0.2em", borderRadius: "3px" },
  "& em": { fontStyle: "italic", color: "text.secondary" },
  // Un enlace interno deja el título justo bajo la barra superior, no pegado al borde.
  "& :target": { scrollMarginTop: "88px" },
};

/**
 * Renderiza HTML enriquecido (editado por staff con TinyMCE) aplicando la
 * tipografía del Design Kit. El contenido es de confianza —solo el staff lo
 * edita en el admin— por eso se inyecta directamente. Si en el futuro se
 * permite edición no-staff, sanitizar aquí (p. ej. con DOMPurify).
 */
export default function RichContent({ html }: { html: string }) {
  return <Box dangerouslySetInnerHTML={{ __html: html }} sx={estilosContenido} />;
}
